import React, { useEffect } from 'react';
import '../assets/styles/pages/_pressForm.scss';
import PropTypes, { object } from 'prop-types';
import { startLoader } from '../components/common/Loader';
import { PressForm as PressFormPopup } from '../components';
import { userActions } from '../redux/actions';
import { connect } from 'react-redux';
import { SEO } from '../utils';

const PressForm = ({
  getPressFormData,
  pressFormData,
  pressData,
  ...props
}) => {
  useEffect(() => {
    props.getMeta('Press Accreditation Form');
    startLoader();
    getPressFormData();
  }, [getPressFormData]);

  const metaData = props.metaData?.res;
  const data = pressFormData?.items;
  const banner = pressData?.items?.res?.banner;

  return (
    <>
      <SEO
        title={metaData && metaData.title}
        description={metaData && metaData.description}
        img={metaData && metaData.image}
        keywords={metaData && metaData.key}
      />

      <PressFormPopup data={data && data} />
    </>
  );
};

PressForm.propTypes = {
  getPressFormData: PropTypes.func,
  pressFormData: object,
  pressData: object,
};

function mapState (state) {
  return {
    pressData: state.getPress,
    pressFormData: state.getPressFormData,
    metaData: state.getMeta,
  };
}

const actionCreators = {
  getPressData: userActions.getPressData,
  getPressFormData: userActions.getPressFormData,
  getMeta: userActions.getMetaData,
};

PressForm.fetchMeta = () => actionCreators.getMeta('Press Accreditation Form');
PressForm.serverFetch = () => actionCreators.getPressData();

export default connect(mapState, actionCreators)(PressForm);
